import { Component, Input, OnInit } from '@angular/core';
import { INotifyTemplate } from '../../models/notify-template.interface';

@Component({
  selector: 'upsc-notify-template-thumbnail',
  templateUrl: './notify-template-thumbnail.component.html',
  styleUrls: ['./notify-template-thumbnail.component.scss'],
})
export class NotifyTemplateThumbnailComponent implements OnInit {
  @Input() template: INotifyTemplate;

  public showcaseItems = [];

  constructor() {
  }

  public ngOnInit() {
    if (this.template.ShowCaseImg1S3Url) {
      this.showcaseItems.push(this.template.ShowCaseImg1S3Url);
    }

    if (this.template.ShowCaseImg2S3Url) {
      this.showcaseItems.push(this.template.ShowCaseImg2S3Url);
    }

    if (this.template.ShowCaseImg3S3Url) {
      this.showcaseItems.push(this.template.ShowCaseImg3S3Url);
    }
  }
}
